<template >
  <div id="main_template">

      <div id="margin"></div>
      <div class="md-card" style="flex:6;padding:2em">
        <form novalidate   >
          <div  style="top:100px;margin:0px">
            <div style="text-align:right">
              <multiselect @select="changeProposal" v-model="operation_title"  track-by="text" label="text" id="proposal" placeholder="نوع پیشنهاد خود را انتخاب کنید" :options="proposals"  :allow-empty="false">
                    <template slot="singleLabel" slot-scope="{ option }">{{option.text}}</template>
              </multiselect>
            </div>
            <div  v-if="0<=proposal_type && proposal_type<=3">

              <md-card-header>
                <div class="md-title" >{{proposals.find(_proposal=>_proposal.value==proposal_type).text}} </div>
              </md-card-header>

              <md-card-content>
                  
                  <md-field >
                      <label >نشانی فایل پیشنهاد</label>
                      <md-input required v-model="proposal_url"></md-input>
                  </md-field>
                  <md-field >
                      <label >هش فایل پیشنهاد</label>
                      <md-input required v-model="proposal_hash"></md-input>
                  </md-field>
                  <md-field v-if="proposal_type==0">
                      <label >نشانی وبگاه میزبان</label>
                      <md-input required v-model="anchor_url"></md-input>
                  </md-field>
                  <md-field >
                      <label >نام میزبان</label>
                      <md-input required v-model="anchor_name"></md-input>
                  </md-field>
                  <div v-if="proposal_type==0 || proposal_type==1">
                    <md-field >
                      <label for="last-name"> نشانی اتریومی نماینده 1</label>
                      <md-input required v-model="members[0]"  />
                    </md-field>
                    <md-field >
                      <label for="last-name"> نشانی اتریومی نماینده 2</label>
                      <md-input required v-model="members[1]"  />
                    </md-field>
                  </div>

              </md-card-content>
            </div>
            <div v-if="proposal_type==4">
              <md-card-content>
                  <md-field >
                    <label for="token_count"> تعداد توکن</label>
                    <md-input type="number"  readOnly v-model="token_count" name="token_count" id="token_count"  />
                  </md-field>
                  <md-field >
                    <label for="first-name"> فایل پیشنهادی url</label>
                    <md-input  v-model="proposal_url" id="first-name"  />
                  </md-field>
                  <md-field >
                    <label for="first-name">هش فایل پیشنهاد</label>
                    <md-input v-model="proposal_hash"  id="first-name"  />
                  </md-field>
              </md-card-content>
              
            </div>
            
            <div v-if="proposal_type==6">



              <md-card-content>
                  <md-field >
                    <label for="last-name">عنوان پیشنهاد</label>
                    <md-input v-model="newProposalTitle"  />
                  </md-field>
                  <md-field >
                    <label for="first-name"> فایل پیشنهادی url</label>
                    <md-input  v-model="proposal_url" id="first-name"  />
                  </md-field>
                  <md-field >
                    <label for="first-name">هش فایل پیشنهاد</label>
                    <md-input v-model="proposal_hash" id="first-name"  />
                  </md-field>
                  
              </md-card-content>
            </div>

            <div v-if="proposal_type==7">


              <md-card-content>
                  <md-field >
                    <label for="last-name">عنوان پیشنهاد</label>
                    <md-input v-model="newProposalTitle"  />
                  </md-field>
                  <md-field >
                    <label for="xdr">تراکنش XDR </label>
                    <md-textarea name="xdr" v-model="xdr" id="xdr"></md-textarea>
                  </md-field>
                  <md-field >
                    <label for="first-name">هش تراکنش</label>
                    <md-input v-model="proposal_hash"  id="first-name"  />
                  </md-field>
                  
              </md-card-content>
            </div>
            <div v-if="proposal_type==8">


              <md-card-content>
                  <md-field >
                    <label for="last-name">عنوان پیشنهاد</label>
                    <md-input v-model="newProposalTitle"  />
                  </md-field>
                  <md-field >
                    <label for="xdr">تراکنش XDR </label>
                    <md-textarea name="xdr" v-model="xdr" id="xdr"></md-textarea>
                  </md-field>
                  <md-field >
                    <label for="first-name">هش تراکنش</label>
                    <md-input v-model="proposal_hash"  id="first-name"  />
                  </md-field>
                  
              </md-card-content>
            </div>

            <div style="text-align:center">
              <label for="">زمان شروع رای گیری</label>
                <date-picker type="datetime" id="register_date"  v-model="proposal_starttime"></date-picker>
            </div>
            <div style="text-align:center">
              <label for="">مهلت رای</label>
                <date-picker type="datetime" id="register_date"  v-model="proposal_deadline"></date-picker>
            </div>

            <md-card-actions>
              <md-button class="md-dense md-primary" @click="submitVoting">ثبت پیشنهاد</md-button>
            </md-card-actions>
          </div>
        </form>
      </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import ContractUtils from '../contract'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import Background from '../assets/backgrnd2.png'
import moment from 'moment-jalaali';
export default {
  name: 'BasicSelect',
  components: { Multiselect },
  computed:mapGetters(['contract','account','web3','net_members']),
  data: () => ({
    Background,
    VotingContract:null,
    xdr:"",
    xdr_decoded:"",
    proposal_url:"",
    proposalsCount:null,
    anchor_url:"",
    operation_title:"",
    proposal_type:0,
    register_date:"",
    proposal_deadline:"",
    proposal_starttime:"",
    newProposalTitle:"",
    proposal_hash:"",
    anchor:"",
    anchor_name:"",
    token_count:null,
    members:[],
    proposals:[
      {text:"افزودن میزبان جدید",value:0},
      {text:"تغییر نماینده میزبان",value:1},
      {text:"حذف میزبان",value:2},
      {text:"مقداردهی  توکن به اعضا",value:4},
      {text:"پیشنهاد عمومی",value:6},
      {text:"پیشنهاد تراکنش ققنوسی",value:7},
      {text:"پیشنهاد دریافت از توزیع ماهیانه",value:8},

      ],
    hosts:[
      {text:"شرکت داده پردازی پارسیان وابسته به بانک پارسیان	",value:1},
      {text:"شرکت داده ورزی سداد وابسته به بانک ملی	",value:2},
      {text:"گروه فن‌آوران هوشمند بهسازان فردا وابسته به بانک ملت	",value:3},
      {text:"(سرمایه‌گذاران فناوری تک وستا (گروه توسن	",value:4},
      {text:"شرکت فناوری اطلاعات و ارتباطات پاسارگاد آریان (فناپ) وابسته به بانک پاسارگاد	",value:5},
      {text:"شرکت سهامی خاص فناوری های اطلاعاتی و مالی توزیع شده یکتا ققنوس پارس	",value:6}
    ],
  }),
  mounted(){
    let VotingContract = ContractUtils.getContract();
    VotingContract && VotingContract.methods
      .accessTokensCount()
      .call()
      .then(data=>{
          console.log(data)
          this.token_count =  parseInt(data.toString())
        }
      )
    
  },
  
  methods:{

    changeProposal(proposal){
      this.proposal_type = proposal.value;
    },
    changeAnchor(anchor){
      this.anchor_id = anchor.value
    },
    submitVoting(){
      let {anchor_name,anchor_url,members,proposal_deadline,proposal_starttime,proposal_type,proposal_url,proposal_hash} = this;
      proposal_deadline = Math.round(moment(proposal_deadline,'jYYYY/jMM/jDD HH:mm').valueOf()/1000);
      proposal_starttime = Math.round(moment(proposal_starttime,'jYYYY/jMM/jDD HH:mm').valueOf()/1000);

      let VotingContract = ContractUtils.getContract();
      let existing_members = _.union(this.net_members.map(mem=>mem.member))
      if(proposal_type == 0){
        if(this.members[0] == this.members[1]){
          this.$toastr.error("لطفاً 2 نماینده با آدرس مجزا انتخاب کنید")
          return
        }
        let intersection = _.intersection(existing_members , this.members);
        if(intersection.length > 0){
          this.$toastr.error("شما قادر به انتخاب نمایندگان موجود به عنوان نماینده ی خود نیستید")
          return
        }
      }
      

      switch (proposal_type) {
        case 0:
          if(!(anchor_name && anchor_url && members.length ==2  && proposal_deadline  && this.proposal_url && this.proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          if(this.proposal_hash.length != 64){
            this.$toastr.error('وارد کنید SHA256 لطفاً یک هش معتبر بر مبنای الگوریتم ')
          }
          if(!this.web3.isAddress(members[0]) || !this.web3.isAddress(members[1])){
            this.$toastr.error('آدرس اتریومی معتبر وارد کنید')
          }
          VotingContract.methods.registerAddOrUpdateAnchorProposal(
            this.anchor_name,
            this.anchor_url,
            this.members,
            proposal_starttime,
            proposal_deadline,
            this.proposal_url,
            this.proposal_hash,
            this.proposal_type
          ).send({from:this.account})
          .then(data=>{
          }).catch(err=>{
          })
          break;
        case 1:
          if(!(anchor_name && members.length ==2  && proposal_deadline &&  this.proposal_url && this.proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          if(this.proposal_hash.length != 64){
            this.$toastr.error('وارد کنید SHA256 لطفاً یک هش معتبر بر مبنای الگوریتم ')
          }
          if(!this.web3.isAddress(members[0]) || !this.web3.isAddress(members[1])){
            this.$toastr.error('آدرس اتریومی معتبر وارد کنید')
          }
          VotingContract.methods.registerAddOrUpdateAnchorProposal(
            this.anchor_name,
            this.anchor_url,
            this.members,
            proposal_starttime,
            proposal_deadline,
            this.proposal_url,
            this.proposal_hash,
            this.proposal_type
          ).send({from:this.account})
          .then(data=>{
          }).catch(err=>{
          })
          break;
        case 2:
          if(!(this.anchor_name  && this.proposal_deadline && this.proposal_url && this.proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          if(this.proposal_hash.length != 64){
            this.$toastr.error('وارد کنید SHA256 لطفاً یک هش معتبر بر مبنای الگوریتم ')
          }
          VotingContract.methods.registerRemoveAnchorProposal(
            this.anchor_name,
            proposal_starttime,
            proposal_deadline,
            this.proposal_url,
            this.proposal_hash
          ).send({from:this.account})
          .then(data=>{
          }).catch(err=>{
          });
          break;
        case 4 :
          const{token_count,proposal_hash,proposal_url} = this.$data;
          if(!( token_count > 0 && proposal_deadline  && proposal_url && proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          if(proposal_hash.length != 64){
            this.$toastr.error('وارد کنید SHA256 لطفاً یک هش معتبر بر مبنای الگوریتم ')
            return;
          }
          VotingContract.methods.registerSetAccessTokenProposal(
            token_count,
            proposal_starttime,
            proposal_deadline,
            proposal_url,
            proposal_hash
          ).send({from:this.account})
            .then(data=>{
            }).catch(err=>{
            })
          break
        case 6 :
          if(!(  this.proposal_url  && this.newProposalTitle && this.proposal_starttime && this.proposal_deadline && this.proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          VotingContract.methods.addCustomProposal(
            this.newProposalTitle,
            this.proposal_type,
            proposal_starttime,
            proposal_deadline,
            this.proposal_url,
            this.proposal_hash
          ).send({from:this.account})
            .then(data=>{
            }).catch(err=>{
            })
          break;
        case 7 :
        case 8 :
          if(!(  this.xdr  && this.newProposalTitle && this.proposal_deadline && this.proposal_hash))
          {
            this.$toastr.error('پرکردن تمام مولفه های ورودی ضروری است');
            return;
          }
          VotingContract.methods.addCustomProposal(
            this.newProposalTitle,
            7,
            proposal_starttime,
            proposal_deadline,
            this.xdr,
            this.proposal_hash
          ).send({from:this.account})
            .then(data=>{
            }).catch(err=>{
            })
        default:
          break;
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

  .md-card{
    /* background-color: white; */
    padding:1em;
  }
  #main_template{
    
    
    /* background-image: url(../assets/backgrnd2.png);
    background-size: cover ;
    height: 150vh; */
    margin-top:.1em; 
    margin-left: 50px;
    display: flex;
    flex-direction: row-reverse
  }
  #margin{
    background-image: url(../assets/backgrnd2.png);
    flex: 3
  }
  .md-field > input,.md-field > textarea{
    text-align: right;
    background-color: white 
  }
  .md-title{
    color:white;
    text-align: center;
  }

</style>
